import styled from "styled-components";
import {
  FlatButton as FlatButtonUI,
  NumberInput as NumberInputUI,
  IconToggle,
  Chip,
  Blank as BlankUI,
  Popup as PopupUI,
  transition,
  InputsGroup,
  Description,
  Flex,
} from "@evergis/ui";
import background from "../../assets/background.png";

export const VerticalContainer = styled.span<{ show?: boolean }>`
  display: flex;
  flex-direction: column;
  flex-grow: 0;

  max-height: ${({ show }) => `${show ? 750 : 0}px`};
  opacity: ${({ show }) => +show};
  margin-top: ${({ show }) => `${show ? 0 : -1}rem`};
  transition: ${transition.show} 0s;
  transition-property: max-height, opacity, margin;
  overflow: hidden;

  > * {
    flex-shrink: 0;
  }
`;

interface IResultTitleProps {
  bold?: boolean;
  italic?: boolean;
  fontSize?: number;
  fontFamily?: string;
  maxWidth?: number;
  halo?: {
    width?: number;
    color?: string;
  };
  fontColor?: string;
  content?: string;
}

interface IFontStyleProps extends IResultTitleProps {
  onClick?: VoidFunction;
  isSelected?: boolean;
}

export const ResultBlockContainer = styled.span`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 4rem;
  flex-grow: 1;
  margin-bottom: 1rem;
  overflow: hidden;

  :before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    background: url(${background});
    opacity: 0.25;
  }
`;

export const FlatButton = styled(FlatButtonUI)`
  margin: 0.5rem 0 1rem;
`;

export const ParametersContainer = styled.span`
  display: flex;
  flex-direction: column;

  :not(:last-child) {
    margin-bottom: 1rem;
  }
`;

export const ParametersRow = styled(ParametersContainer)`
  flex-direction: row;
  align-items: flex-end;
`;

export const FontStyle = styled(IconToggle)<IFontStyleProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${({ theme: { palette } }) => palette.icon};
  cursor: pointer;
  font: ${({ theme: { fonts } }) => fonts.subtitle};
  font-family: TimesNewRomanPS-MT, TimesNewRoman, serif;
  font-style: ${({ italic }) => (italic ? "italic" : "normal")};
  ${({ bold }) => bold && "font-weight: bold"};

  :not(:last-of-type) {
    margin-left: 0.25rem;
  }
`;

export const NumberInput = styled(NumberInputUI)`
  margin-left: 1rem;
`;

export const DirectionContainer = styled.span`
  display: flex;
  flex-direction: column;
`;

export const DirectionTitle = styled.span`
  font: ${({ theme: { fonts } }) => fonts.description};
  color: ${({ theme: { palette } }) => palette.textSecondary};
  margin-bottom: 0.25rem;
`;

export const DirectionChipsContainer = styled.span`
  display: flex;
  width: 19.5rem;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 1rem 0;

  > ${ParametersRow} {
    align-items: center;

    :not(:last-of-type) {
      margin-bottom: 0.5rem;
    }
  }
`;

export const DirectionChip = styled(Chip)`
  border-radius: ${({ theme: { borderRadius } }) => borderRadius.smallest};
  padding: 0.125rem 0.25rem;
  justify-content: center;
  cursor: pointer;

  :nth-child(even) {
    min-width: 3.5rem;
  }

  :nth-child(odd) {
    min-width: 4.875rem;
  }

  :not(:last-of-type) {
    margin-right: 0.5rem;
  }

  ${ParametersRow}:nth-of-type(2) > & {
    :nth-child(odd) {
      min-width: 3.5rem;
    }

    :nth-child(even) {
      min-width: 2.875rem;
    }
  }
`;

export const Blank = styled(BlankUI)`
  width: 100%;
  padding: 0.625rem 0;
`;

export const Popup = styled(PopupUI)`
  max-width: 15.75rem;
`;

export const FontStyles = styled.div`
  display: flex;
  margin-top: auto;
`;

export const FontBackgroundSettingsContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: 2rem;

  > label {
    margin-bottom: 1rem;
  }
`;

export const ColorPickerContainer = styled(InputsGroup)`
  > label {
    padding-left: 0;
  }
`;

export const InfoPopoverContainer = styled.div`
  width: 15rem;
  background-color: #fff;
  box-shadow: 0 3px 10px 0 rgba(0, 0, 0, 0.15);
  border-radius: ${({ theme: { borderRadius } }) => borderRadius.smallest};
`;

export const InfoPopoverHeader = styled.div`
  padding: 1rem 1rem 0 1rem;
`;

export const InfoPopoverText = styled(Description)`
  margin-top: 0.25rem;
`;

export const InfoPopoverFooter = styled(Flex)`
  flex-direction: column;
  align-items: center;
  padding: 1.5rem;
  background: ${({ theme: { palette } }) => palette.elementDark};
  font-size: 0.75rem;
  color: ${({ theme: { palette } }) => palette.icon};

  span[kind="rounded_triangle"] {
    transform: rotate(180deg);
  }
`;

export const OffsetMarker = styled.div`
  width: 3.125rem;
  height: 0.5rem;
  background-color: rgba(255, 0, 0, 0.12);
`;

export const OffsetContainer = styled.div`
  margin: 0 0 1rem 2rem;
`;

export const OffsetLabel = styled(Flex)`
  align-items: center;
  margin-bottom: -0.5rem;

  span[kind="info"]:after {
    font-size: 0.875rem;
  }
`;
